export default __webpack_public_path__ + "static/linda-f8615b65dcac78660f49454ce203a218.jpg";